 <template>
  <div>
    <v-row>
      <v-col cols="4" v-for="(year) in lastFiveYears" :key="year">
          <v-text-field   
           :disabled="!isAdmin"               
            prefix="$"
            suffix="MXN"
            dense  
            v-model="debtValues[year]"
            :label="`Adeudo ${year}`"
          ></v-text-field>
        </v-col>    
    </v-row>
  </div>
</template>
 
<script>
export default { 
  props: {
    infoUser: {
      type: Object,
      required: true,
    },   
  },
  data() {
    return {     
      lastFiveYears: null,
      debtValues: [],
    };
  },
  mounted() {    
    if (this.infoUser != null) {
      this.lastFiveYears= this.getLastFiveYears();      
      this.debtValues = this.getDebtArray();
    } 
  },
  computed: {    
    isAdmin() {
      return this.$store.getters['session/user'].role === 'admin';
    },
  },
  watch: {
    infoUser() {
      this.lastFiveYears= this.getLastFiveYears();
      this.debtValues = this.getDebtArray();  
    },
  },  
  methods: {    
    getDebtArray() {         
      const debtsArray = this.infoUser.debts ?? [];
      // Paso 1: convertir debts en mapa {year: debt}
      const debtMap = debtsArray.reduce((acc, d) => {
        if (d && d.year !== undefined) {
          acc[d.year] = d.debt || 0;
        }
        return acc;
      }, {});
      // Paso 2: asegurar todos los años
      let debtValues = [];
       debtValues = this.lastFiveYears.reduce((acc, year) => {
        acc[year] = debtMap[year] ?? 0;
        return acc;
      }, {});
      return debtValues;
    },
    getLastFiveYears () {
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth() + 1;
      const startYear = currentMonth >= 11 ? currentYear + 1 : currentYear;
      return this.lastFiveYears = Array.from({ length: 5 }, (_, i) => startYear - (4 - i));
    },    
  },
};
</script>
<style>
.theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea {
    color: rgba(0, 0, 0, 1) !important;
}
</style>


<style lang="scss" scoped>
@import './src/assets/style.scss';
</style>


